import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import apiJunction from "../../adapters/api";
import StrapiApiEndPoints from "../../config/StrapiApiEndPoints";
import Config from "../../config/app.config.json";

type InitialState = {
  nutritionLabelData: any;
  errorNutritionLabelData: any;
  NLBroadbandFactContentData: any;
  errorNLBroadbandFactContentData: any;
};

const initialState: InitialState = {
  nutritionLabelData: null,
  errorNutritionLabelData: null,
  NLBroadbandFactContentData: null,
  errorNLBroadbandFactContentData: null,
};

// Generates pending, fulfilled and rejected action types
export const NLContentStrapi = createAsyncThunk("NL/NLContentStrapi", () => {
  return apiJunction.makeRequest({
    method: "get",
    url: `/${Config.NutritionLabelPage.NLCard.template}${StrapiApiEndPoints.nutritionLabel}`,
    isStrapiApi: true,
  });
});

export const NLContentBroadbandFactStrapi = createAsyncThunk(
  "checkoutContent/NLContentBroadbandFactStrapi",
  () => {
    return apiJunction.makeRequest({
      method: "get",
      url: `/${StrapiApiEndPoints.broadbandFacts}`,
      isStrapiApi: true,
    });
  }
);

const NLSlice = createSlice({
  name: "nutritionlabel",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      NLContentStrapi.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.nutritionLabelData = action.payload?.data?.data?.attributes;
        state.errorNutritionLabelData = null;
      }
    );
    builder.addCase(NLContentStrapi.rejected, (state, action) => {
      state.nutritionLabelData = null;
      state.errorNutritionLabelData = action.error || "Something went wrong";
    });
    builder.addCase(
      NLContentBroadbandFactStrapi.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.NLBroadbandFactContentData = action.payload?.data?.data?.attributes;
        state.errorNLBroadbandFactContentData = null;
      }
    );
    builder.addCase(NLContentBroadbandFactStrapi.rejected, (state, action) => {
      state.NLBroadbandFactContentData = null;
      state.errorNLBroadbandFactContentData = action.error || "Something went wrong";
    });
  },
});

export default NLSlice.reducer;
